module.exports = __webpack_public_path__ + "img/xlb3.71eeda01.png";